<template>
  <div class="container">
    <div class="form">
      <h1>mibuilding access</h1>
      <input type="text" placeholder="Your work email" />
      <input type="password" placeholder="Your password" />
      <a style="padding: 30px 0px 10px 0;;" href="#">Forgot Password?</a>
      <a href="#" class="full-width btn btn-primary">log in</a>
      <p class="end">
        Don't have nomado account?
        <router-link :to="{ name: 'signup' }">Sign Up</router-link>
      </p>
    </div>
    <div class="news">
      <img src="@/assets/nomado-trunk.svg" />
      <span class="badge" style="margin-top: 20px; align-self: flex-start;">new</span>

      <h2>entrée - smart visitor check-in!</h2>
      <p>
        Help you organise and run your frondesk smoothly and focus on what it supposed to do - customer care. Automated and secure check-in specially designed for you!
      </p>
      <a href="#" class="end">Learn more</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "login-form",
  props: {
    msg: String
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";

h1,
h2 {
  font-weight: 800;
  font-family: "Quicksand";
  font-size: 22px;
}

.container {
  background: white;
  display: flex;
  width: 900px;
  border: 1px solid $off-white;
  box-shadow: 0 10px 45px 0 hsla(0, 0%, 64.3%, 0.3);
}

.form {
  padding: 50px 50px;
  width: 50%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid $off-white;
}

.form > h1 {
  margin-bottom: 50px;
}

.end {
  margin-top: auto;
}
.news {
  padding: 50px 50px;
  width: 50%;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 500px) {
  .container {
    flex-direction: column;
  }
}
</style>
